// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentInfoCard_container__f-5s7"};